// extracted by mini-css-extract-plugin
export default {"delConfirm":"GDelConfirm-module_delConfirm_fffdac16","delConfirmMsg":"GDelConfirm-module_delConfirmMsg_dc1ec77f"};